import { Badge } from "../lib/ui";

export default function OptionsComparison({ comparison, testId = "options-comparison" }) {
  if (!comparison?.options?.length) return null;
  const { options, recommended, why = [], why_not_replatform, why_refactor, label } = comparison;

  return (
    <section className="feature-panel" data-testid={testId}>
      <div className="panel-header">
        <div>
          <p className="kicker">{label || "OPTIONS · ADVISORY"}</p>
          <h2>7R alternatives compared</h2>
        </div>
        <Badge tone="cyan">Model=None</Badge>
      </div>
      <div className="options-score-grid">
        {options.map((opt) => (
          <div
            key={opt.strategy}
            className={opt.strategy === recommended ? "option-card winner" : "option-card"}
            data-testid={`option-card-${opt.strategy.replace(/\s+/g, "-").toLowerCase()}`}
          >
            <strong>{opt.strategy}</strong>
            <span>{opt.suitability}% suitability</span>
            <small>{opt.eligibility} · conf {opt.confidence}%</small>
            <em>Cost {opt.cost} · Risk {opt.risk}</em>
          </div>
        ))}
      </div>
      {(why.length > 0 || why_not_replatform || why_refactor) && (
        <div className="options-narrative" data-testid="options-narrative">
          {why.filter(Boolean).map((line) => (
            <p key={line} className="muted small-note">{line}</p>
          ))}
          {why_refactor && (
            <p className="muted small-note"><strong>Why {recommended}:</strong> {why_refactor}</p>
          )}
          {why_not_replatform && recommended !== "Replatform" && (
            <p className="muted small-note"><strong>Why not Replatform:</strong> {why_not_replatform}</p>
          )}
        </div>
      )}
    </section>
  );
}
